import React from 'react'
import { useWatch } from 'react-hook-form'
import { FormField } from '../forms/FormField'
import { SelectField } from '../forms/SelectField'
import { YES_NO_OPTIONS } from './profileStepOptions'
import type { FnaFormValues } from '../../contracts/fnaFormSchema'

/**
 * Step 5: Life insurance coverage.
 *
 * @returns JSX.Element The insurance step
 */
export function InsuranceStep(): JSX.Element {
  const lifeInsurance = useWatch<FnaFormValues, 'lifeInsurance'>({ name: 'lifeInsurance' })
  return (
    <>
      <h2>Insurance</h2>
      <SelectField<FnaFormValues>
        name="lifeInsurance"
        label="Do you have life insurance?"
        options={YES_NO_OPTIONS}
      />
      {lifeInsurance === 'yes' && (
        <FormField<FnaFormValues>
          name="insuredAmount"
          label="Insured amount"
          type="number"
          placeholder="0"
          inputMode="decimal"
        />
      )}
    </>
  )
}
